<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Edit Employee</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)" @click="gotTo('/')">Home</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)" @click="gotTo('employee-register')">Employees</a></li>
                    <li class="breadcrumb-item active">Edit Employee</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Progress Indicator -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body py-3">
                  <div class="progress-nav">
                    <div class="progress-steps">
                      <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
                        <div class="step-number">1</div>
                        <div class="step-title">Personal Info</div>
                      </div>
                      <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
                        <div class="step-number">2</div>
                        <div class="step-title">Government IDs</div>
                      </div>
                      <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
                        <div class="step-number">3</div>
                        <div class="step-title">Documents</div>
                      </div>
                      <div class="step" :class="{ active: currentStep >= 4, completed: currentStep > 4 }">
                        <div class="step-number">4</div>
                        <div class="step-title">Emergency Contacts</div>
                      </div>
                      <div class="step" :class="{ active: currentStep >= 5, completed: currentStep > 5 }">
                        <div class="step-number">5</div>
                        <div class="step-title">Next of Kin</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Form -->
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <!-- Step 1: Personal Information -->
              <div v-show="currentStep === 1" class="card">
                <div class="card-header text-white">
                  <h5 class="mb-0">
                    <i class="mdi mdi-account-circle me-2"></i>
                    Personal Information
                  </h5>
                </div>

                <div class="card-body">
                  <div class="row">
                    <!-- Employee Number -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Employee Number <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-identifier"></i></span>
                        <input
                            v-model="employee.empNo"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': errors.empNo}"
                            placeholder="e.g., EMP001"
                            @blur="validateField('empNo')"
                        >
                      </div>
                      <small v-if="errors.empNo" class="text-danger">{{ errors.empNo }}</small>
                    </div>

                    <!-- First Name -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        First Name <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                        <input
                            v-model="employee.firstName"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': errors.firstName}"
                            placeholder="Enter first name"
                            @blur="validateField('firstName')"
                        >
                      </div>
                      <small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
                    </div>

                    <!-- Middle Name -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Middle Name <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                        <input
                            v-model="employee.middleName"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': errors.middleName}"
                            placeholder="Enter middle name"
                            @blur="validateField('middleName')"
                        >
                      </div>
                      <small v-if="errors.middleName" class="text-danger">{{ errors.middleName }}</small>
                    </div>

                    <!-- Last Name -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Last Name <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-account"></i></span>
                        <input
                            v-model="employee.lastName"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': errors.lastName}"
                            placeholder="Enter last name"
                            @blur="validateField('lastName')"
                        >
                      </div>
                      <small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
                    </div>

                    <!-- Email -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Email Address <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-email"></i></span>
                        <input
                            v-model="employee.email"
                            type="email"
                            class="form-control"
                            :class="{'is-invalid': errors.email}"
                            placeholder="email@example.com"
                            @blur="validateField('email')"
                        >
                      </div>
                      <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
                    </div>

                    <!-- Phone -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Phone Number <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-phone"></i></span>
                        <input
                            v-model="employee.phone"
                            type="tel"
                            class="form-control"
                            :class="{'is-invalid': errors.phone}"
                            placeholder="07XXXXXXXX"
                            @blur="validateField('phone')"
                        >
                      </div>
                      <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                    </div>

                    <!-- National ID -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        National ID <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-card-account-details"></i></span>
                        <input
                            v-model="employee.nationalId"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': errors.nationalId}"
                            placeholder="Enter ID number"
                            @blur="validateField('nationalId')"
                        >
                      </div>
                      <small v-if="errors.nationalId" class="text-danger">{{ errors.nationalId }}</small>
                    </div>

                    <!-- Gender -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Gender <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-gender-male-female"></i></span>
                        <select
                            v-model="employee.gender"
                            class="form-select"
                            :class="{'is-invalid': errors.gender}"
                            @change="validateField('gender')"
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <small v-if="errors.gender" class="text-danger">{{ errors.gender }}</small>
                    </div>

                    <!-- Date of Birth -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Date of Birth <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-calendar"></i></span>
                        <input
                            v-model="employee.dateOfBirth"
                            type="date"
                            class="form-control"
                            :class="{'is-invalid': errors.dateOfBirth}"
                            :max="maxDate"
                            @blur="validateField('dateOfBirth')"
                        >
                      </div>
                      <small v-if="errors.dateOfBirth" class="text-danger">{{ errors.dateOfBirth }}</small>
                    </div>

                    <!-- Nationality -->
                    <div class="col-md-6 col-lg-4 mb-3">
                      <label class="form-label">
                        Nationality <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-flag"></i></span>
                        <select
                            v-model="employee.nationality"
                            class="form-select"
                            :class="{'is-invalid': errors.nationality}"
                            @change="onNationalityChange"
                        >
                          <option value="">Select Country</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Tanzania">Tanzania</option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="India">India</option>
                          <option value="United States">United States</option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <small v-if="errors.nationality" class="text-danger">{{ errors.nationality }}</small>
                    </div>

                    <!-- Department -->
                    <div class="col-md-6 mb-3">
                      <label class="form-label">
                        Department <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-office-building"></i></span>
                        <select
                            v-model="employee.departmentID"
                            class="form-select"
                            :class="{'is-invalid': errors.departmentID}"
                            @change="validateField('departmentID')"
                        >
                          <option value="">Select Department</option>
                          <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                            {{ dept.departmentName }}
                          </option>
                        </select>
                      </div>
                      <small v-if="errors.departmentID" class="text-danger">{{ errors.departmentID }}</small>
                    </div>

                    <!-- Employment Type -->
                    <div class="col-md-6 mb-3">
                      <label class="form-label">
                        Employment Type <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-badge-account"></i></span>
                        <select
                            v-model="employee.employmentType"
                            class="form-select"
                            :class="{'is-invalid': errors.employmentType}"
                            @change="validateField('employmentType')"
                        >
                          <option value="">Select Type</option>
                          <option value="Permanent">Permanent</option>
                          <option value="Contract">Contract</option>
                          <option value="Temporary">Temporary</option>
                          <option value="Intern">Intern</option>
                          <option value="Consultant">Consultant</option>
                        </select>
                      </div>
                      <small v-if="errors.employmentType" class="text-danger">{{ errors.employmentType }}</small>
                    </div>

                    <!-- Hire Date -->
                    <div class="col-md-6 mb-3">
                      <label class="form-label">
                        Hire Date <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-calendar-check"></i></span>
                        <input
                            v-model="employee.hireDate"
                            type="date"
                            class="form-control"
                            :class="{'is-invalid': errors.hireDate}"
                            @blur="validateField('hireDate')"
                        >
                      </div>
                      <small v-if="errors.hireDate" class="text-danger">{{ errors.hireDate }}</small>
                    </div>

                    <!-- Status -->
                    <div class="col-md-6 mb-3">
                      <label class="form-label">
                        Status <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-check-circle"></i></span>
                        <select
                            v-model="employee.status"
                            class="form-select"
                            :class="{'is-invalid': errors.status}"
                            @change="validateField('status')"
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                          <option value="Suspended">Suspended</option>
                          <option value="Terminated">Terminated</option>
                        </select>
                      </div>
                      <small v-if="errors.status" class="text-danger">{{ errors.status }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 2: Government IDs -->
              <div v-show="currentStep === 2" class="card">
                <div class="card-header text-white">
                  <h5 class="mb-0">
                    <i class="mdi mdi-card-account-details-outline me-2"></i>
                    Government Identification Numbers
                  </h5>
                </div>

                <div class="card-body">
                  <div class="alert alert-info">
                    <i class="mdi mdi-information me-2"></i>
                    <strong>Required IDs for {{ employee.nationality || 'selected country' }}:</strong>
                    Please provide all mandatory government identification numbers. Fields marked with
                    <span class="text-danger">*</span> are required.
                  </div>

                  <div v-if="filteredGovernmentIdTypes.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <div class="avatar-title bg-light text-warning rounded-circle">
                        <i class="mdi mdi-alert-outline font-size-24"></i>
                      </div>
                    </div>
                    <h5 class="mt-4">No ID types configured</h5>
                    <p class="text-muted">Please select a nationality in the previous step to see required IDs.</p>
                  </div>

                  <div v-else class="row">
                    <div v-for="idType in filteredGovernmentIdTypes" :key="idType.id" class="col-md-6 mb-4">
                      <div class="border rounded p-3 h-100" :class="{'border-danger': idType.is_mandatory && !getGovIdValue(idType.id_type_code, 'id_number')}">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <label class="form-label fw-bold mb-1">
                              {{ idType.id_type_name }}
                              <span v-if="idType.is_mandatory" class="text-danger">*</span>
                              <span v-else class="badge bg-secondary ms-1">Optional</span>
                            </label>
                            <p class="text-muted small mb-2">{{ idType.description }}</p>
                            <small v-if="idType.format_example" class="text-muted">
                              <i class="mdi mdi-information-outline me-1"></i>
                              Format: {{ idType.format_example }}
                            </small>
                          </div>
                          <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="`active-${idType.id}`"
                                :checked="getGovIdValue(idType.id_type_code, 'is_active') !== 0"
                                @change="updateGovIdField(idType.id_type_code, 'is_active', $event.target.checked ? 1 : 0)"
                                :disabled="idType.is_mandatory"
                            >
                            <label class="form-check-label small" :for="`active-${idType.id}`">
                              Active
                            </label>
                          </div>
                        </div>

                        <div class="mb-3">
                          <input
                              :value="getGovIdValue(idType.id_type_code, 'id_number')"
                              @input="updateGovIdField(idType.id_type_code, 'id_number', $event.target.value)"
                              type="text"
                              class="form-control"
                              :class="{'is-invalid': governmentIdErrors[idType.id_type_code]}"
                              :placeholder="`Enter ${idType.id_type_name}`"
                              :maxlength="idType.max_length"
                              @blur="validateGovernmentId(idType)"
                          >
                          <small v-if="governmentIdErrors[idType.id_type_code]" class="text-danger">
                            {{ governmentIdErrors[idType.id_type_code] }}
                          </small>
                        </div>

                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label class="form-label small">Issue Date</label>
                            <input
                                :value="getGovIdValue(idType.id_type_code, 'issue_date')"
                                @input="updateGovIdField(idType.id_type_code, 'issue_date', $event.target.value)"
                                type="date"
                                class="form-control form-control-sm"
                            >
                          </div>
                          <div class="col-md-6 mb-2" v-if="idType.requires_expiry">
                            <label class="form-label small">Expiry Date <span class="text-danger">*</span></label>
                            <input
                                :value="getGovIdValue(idType.id_type_code, 'expiry_date')"
                                @input="updateGovIdField(idType.id_type_code, 'expiry_date', $event.target.value)"
                                type="date"
                                class="form-control form-control-sm"
                                :min="today"
                            >
                          </div>
                        </div>

                        <div class="mb-2">
                          <label class="form-label small">Notes</label>
                          <textarea
                              :value="getGovIdValue(idType.id_type_code, 'notes')"
                              @input="updateGovIdField(idType.id_type_code, 'notes', $event.target.value)"
                              class="form-control form-control-sm"
                              rows="2"
                              placeholder="Additional notes (optional)"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 3: Documents -->
              <div v-show="currentStep === 3" class="card">
                <div class="card-header text-white">
                  <h5 class="mb-0">
                    <i class="mdi mdi-file-document-multiple me-2"></i>
                    Employee Documents
                  </h5>
                </div>

                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <p class="text-muted mb-0">Add and manage employee documents. You can add multiple documents of different types.</p>
                    </div>
                    <button @click="addDocument" type="button" class="btn btn-primary btn-sm">
                      <i class="mdi mdi-plus-circle me-1"></i>
                      Add Document
                    </button>
                  </div>

                  <div v-if="documents.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <div class="avatar-title bg-light text-primary rounded-circle">
                        <i class="mdi mdi-file-document-plus-outline font-size-24"></i>
                      </div>
                    </div>
                    <h5 class="mt-4">No documents added</h5>
                    <p class="text-muted">Click "Add Document" to start adding employee documents</p>
                  </div>

                  <div v-else>
                    <div v-for="(doc, index) in documents" :key="index" class="border rounded p-3 mb-3">
                      <div class="row">
                        <div class="col-md-3 mb-3">
                          <label class="form-label">Document Type <span class="text-danger">*</span></label>
                          <select v-model="doc.documentType" @change="onDocumentTypeChange(index, $event)" class="form-select" :class="{'is-invalid': doc.errors?.documentType}">
                            <option value="">Select Type</option>
                            <option v-for="docType in documentTypes" :key="docType.id" :value="docType.type_name">
                              {{ docType.type_name }}
                            </option>
                          </select>
                          <small v-if="doc.errors?.documentType" class="text-danger">{{ doc.errors.documentType }}</small>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Document Name <span class="text-danger">*</span></label>
                          <input v-model="doc.name" type="text" class="form-control" :class="{'is-invalid': doc.errors?.name}" placeholder="e.g., University Certificate">
                          <small v-if="doc.errors?.name" class="text-danger">{{ doc.errors.name }}</small>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Document Number</label>
                          <input v-model="doc.documentNumber" type="text" class="form-control" placeholder="Certificate/License number">
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Valid Until</label>
                          <input v-model="doc.validTill" type="date" class="form-control">
                        </div>

                        <div class="col-md-6 mb-3">
                          <label class="form-label">Upload Document</label>
                          <input
                              @change="onDocumentFileChange(index, $event)"
                              type="file"
                              class="form-control"
                              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                              :disabled="doc.uploading"
                          >
                          <small class="text-muted">Supported formats: PDF, JPG, PNG, DOC, DOCX (Max: 5MB)</small>

                          <div v-if="doc.uploading" class="mt-2">
                            <div class="d-flex align-items-center">
                              <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                              <small class="text-primary">Uploading...</small>
                            </div>
                          </div>

                          <div v-if="doc.filePath && !doc.uploading" class="mt-2">
                            <div class="alert alert-success py-2 mb-0">
                              <i class="mdi mdi-check-circle me-2"></i>
                              <small>{{ doc.originalFileName || doc.name }} uploaded successfully</small>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 mb-3 d-flex align-items-end">
                          <button @click="removeDocument(index)" type="button" class="btn btn-outline-danger btn-sm">
                            <i class="mdi mdi-trash-can me-1"></i>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 4: Emergency Contacts -->
              <div v-show="currentStep === 4" class="card">
                <div class="card-header text-white">
                  <h5 class="mb-0">
                    <i class="mdi mdi-phone-alert me-2"></i>
                    Emergency Contacts
                  </h5>
                </div>

                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <p class="text-muted mb-0">Add emergency contact persons who can be reached in case of emergencies.</p>
                    </div>
                    <button @click="addEmergencyContact" type="button" class="btn btn-primary btn-sm">
                      <i class="mdi mdi-plus-circle me-1"></i>
                      Add Contact
                    </button>
                  </div>

                  <div v-if="emergencyContacts.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <div class="avatar-title bg-light text-primary rounded-circle">
                        <i class="mdi mdi-phone-plus font-size-24"></i>
                      </div>
                    </div>
                    <h5 class="mt-4">No emergency contacts added</h5>
                    <p class="text-muted">Click "Add Contact" to add emergency contact persons</p>
                  </div>

                  <div v-else>
                    <div v-for="(contact, index) in emergencyContacts" :key="index" class="border rounded p-3 mb-3">
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <label class="form-label">Full Name <span class="text-danger">*</span></label>
                          <input v-model="contact.name" type="text" class="form-control" :class="{'is-invalid': contact.errors?.name}" placeholder="Contact person name">
                          <small v-if="contact.errors?.name" class="text-danger">{{ contact.errors.name }}</small>
                        </div>

                        <div class="col-md-4 mb-3">
                          <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                          <input v-model="contact.phoneNumber" type="tel" class="form-control" :class="{'is-invalid': contact.errors?.phoneNumber}" placeholder="07XXXXXXXX">
                          <small v-if="contact.errors?.phoneNumber" class="text-danger">{{ contact.errors.phoneNumber }}</small>
                        </div>

                        <div class="col-md-4 mb-3">
                          <label class="form-label">Relationship <span class="text-danger">*</span></label>
                          <select v-model="contact.relationship" class="form-select" :class="{'is-invalid': contact.errors?.relationship}">
                            <option value="">Select Relationship</option>
                            <option v-for="relType in relationshipTypes" :key="relType.id" :value="relType.relationship_name">
                              {{ relType.relationship_name }}
                            </option>
                          </select>
                          <small v-if="contact.errors?.relationship" class="text-danger">{{ contact.errors.relationship }}</small>
                        </div>

                        <div class="col-md-8 mb-3">
                          <label class="form-label">Email Address</label>
                          <input v-model="contact.email" type="email" class="form-control" placeholder="contact@example.com">
                        </div>

                        <div class="col-md-4 mb-3 d-flex align-items-end">
                          <button @click="removeEmergencyContact(index)" type="button" class="btn btn-outline-danger btn-sm">
                            <i class="mdi mdi-trash-can me-1"></i>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 5: Next of Kin -->
              <div v-show="currentStep === 5" class="card">
                <div class="card-header text-white">
                  <h5 class="mb-0">
                    <i class="mdi mdi-account-heart me-2"></i>
                    Next of Kin & Beneficiaries
                  </h5>
                </div>

                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <p class="text-muted mb-0">Add next of kin and beneficiaries for insurance and benefit purposes.</p>
                    </div>
                    <button @click="addNextOfKin" type="button" class="btn btn-primary btn-sm">
                      <i class="mdi mdi-plus-circle me-1"></i>
                      Add Next of Kin
                    </button>
                  </div>

                  <div v-if="nextOfKin.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <div class="avatar-title bg-light text-primary rounded-circle">
                        <i class="mdi mdi-account-plus font-size-24"></i>
                      </div>
                    </div>
                    <h5 class="mt-4">No next of kin added</h5>
                    <p class="text-muted">Click "Add Next of Kin" to add beneficiaries</p>
                  </div>

                  <div v-else>
                    <div v-for="(kin, index) in nextOfKin" :key="index" class="border rounded p-3 mb-3">
                      <div class="row">
                        <div class="col-md-3 mb-3">
                          <label class="form-label">Full Name <span class="text-danger">*</span></label>
                          <input v-model="kin.name" type="text" class="form-control" :class="{'is-invalid': kin.errors?.name}" placeholder="Beneficiary name">
                          <small v-if="kin.errors?.name" class="text-danger">{{ kin.errors.name }}</small>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                          <input v-model="kin.phoneNumber" type="tel" class="form-control" :class="{'is-invalid': kin.errors?.phoneNumber}" placeholder="07XXXXXXXX">
                          <small v-if="kin.errors?.phoneNumber" class="text-danger">{{ kin.errors.phoneNumber }}</small>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Relationship <span class="text-danger">*</span></label>
                          <select v-model="kin.relationship" class="form-select" :class="{'is-invalid': kin.errors?.relationship}">
                            <option value="">Select Relationship</option>
                            <option v-for="relType in relationshipTypes" :key="relType.id" :value="relType.relationship_name">
                              {{ relType.relationship_name }}
                            </option>
                          </select>
                          <small v-if="kin.errors?.relationship" class="text-danger">{{ kin.errors.relationship }}</small>
                        </div>

                        <div class="col-md-3 mb-3">
                          <label class="form-label">Email Address</label>
                          <input v-model="kin.email" type="email" class="form-control" placeholder="kin@example.com">
                        </div>

                        <div class="col-md-8 mb-3">
                          <div class="form-check">
                            <input v-model="kin.isCoveredInBenefits" class="form-check-input" type="checkbox" :id="`benefits-${index}`">
                            <label class="form-check-label" :for="`benefits-${index}`">
                              Include in benefit coverage (insurance, medical, etc.)
                            </label>
                          </div>
                        </div>

                        <div class="col-md-4 mb-3 d-flex align-items-end">
                          <button @click="removeNextOfKin(index)" type="button" class="btn btn-outline-danger btn-sm">
                            <i class="mdi mdi-trash-can me-1"></i>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation Buttons -->
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <button
                        v-if="currentStep > 1"
                        @click="previousStep"
                        type="button"
                        class="btn btn-outline-secondary"
                    >
                      <i class="mdi mdi-arrow-left me-2"></i>
                      Previous
                    </button>
                    <div v-else></div>

                    <div>
                      <button
                          v-if="currentStep < 5"
                          @click="nextStep"
                          type="button"
                          class="btn btn-primary me-2"
                          :disabled="!canProceedToNextStep"
                      >
                        Next
                        <i class="mdi mdi-arrow-right ms-2"></i>
                      </button>
                      <button
                          v-if="currentStep === 5"
                          @click="validateAndSubmit"
                          type="button"
                          class="btn btn-success"
                          :disabled="loading"
                      >
                        <span v-if="!loading">
                          <i class="mdi mdi-content-save me-2"></i>
                          Update Employee
                        </span>
                        <span v-else>
                          <span class="spinner-border spinner-border-sm me-2"></span>
                          Updating...
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Success Modal -->
      <div class="modal fade" id="successModal" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center p-5">
              <div class="mb-4">
                <div class="avatar-lg mx-auto">
                  <div class="avatar-title bg-light text-success rounded-circle">
                    <i class="mdi mdi-check-circle font-size-48"></i>
                  </div>
                </div>
              </div>
              <h4 class="mb-3">Employee Updated Successfully!</h4>
              <p class="text-muted mb-4">{{ successMessage }}</p>
              <div class="d-grid gap-2">
                <button
                    type="button"
                    @click="gotTo('employee-register')"
                    class="btn btn-primary"
                    data-bs-dismiss="modal"
                >
                  <i class="mdi mdi-view-list me-2"></i>
                  Back to Employee List
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Error Modal -->
      <div class="modal fade" id="errorModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center p-5">
              <div class="mb-4">
                <div class="avatar-lg mx-auto">
                  <div class="avatar-title bg-light text-danger rounded-circle">
                    <i class="mdi mdi-alert-circle font-size-48"></i>
                  </div>
                </div>
              </div>
              <h4 class="mb-3">Update Failed</h4>
              <p class="text-muted mb-4">{{ errorMessage }}</p>
              <button
                  type="button"
                  class="btn btn-danger"
                  data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import { authUrl, execute } from "@/api";

export default {
  name: "EmployeeEditEnhanced",
  components: { NavigationBar },
  data() {
    return {
      currentStep: 1,

      employee: {
        id: '',
        empNo: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        phone: '',
        nationalId: '',
        gender: '',
        dateOfBirth: '',
        nationality: 'Kenya',
        employmentType: '',
        hireDate: '',
        departmentID: '',
        departmentName: '',
        status: 'Active'
      },

      governmentIds: [],
      governmentIdTypes: [],
      governmentIdErrors: {},

      documents: [],
      emergencyContacts: [],
      nextOfKin: [],

      departments: [],
      documentTypes: [],
      relationshipTypes: [],

      loading: false,
      errors: {},
      successMessage: '',
      errorMessage: '',
      maxDate: '',
      today: ''
    };
  },

  computed: {
    filteredGovernmentIdTypes() {
      if (!this.employee.nationality) return [];

      const countryMap = {
        'Kenya': 'KE',
        'India': 'IN',
        'United States': 'US',
        'United Kingdom': 'GB'
      };

      const countryCode = countryMap[this.employee.nationality];
      if (!countryCode) return [];

      return this.governmentIdTypes
          .filter(type => type.country_code === countryCode && type.is_active)
          .sort((a, b) => a.display_order - b.display_order);
    },

    canProceedToNextStep() {
      if (this.currentStep === 1) {
        return this.isStep1Valid;
      }
      if (this.currentStep === 2) {
        return this.isStep2Valid;
      }
      return true;
    },

    isStep1Valid() {
      const requiredFields = ['empNo', 'firstName', 'middleName', 'lastName', 'email',
        'phone', 'nationalId', 'gender', 'dateOfBirth', 'nationality',
        'hireDate', 'departmentID', 'employmentType', 'status'];

      return requiredFields.every(field => {
        if (!this.employee[field]) return false;
        if (field === 'email' && !this.isValidEmail(this.employee.email)) return false;
        if (field === 'phone' && !this.isValidPhone(this.employee.phone)) return false;
        return true;
      });
    },

    isStep2Valid() {
      return this.filteredGovernmentIdTypes.every(idType => {
        const govId = this.governmentIds.find(id => id.id_type === idType.id_type_code);

        if (idType.is_mandatory && (!govId || !govId.id_number || govId.id_number.trim() === '')) {
          return false;
        }

        if (govId && govId.id_number) {
          if (idType.min_length && govId.id_number.length < idType.min_length) return false;
          if (idType.max_length && govId.id_number.length > idType.max_length) return false;

          if (idType.format_pattern) {
            const regex = new RegExp(idType.format_pattern);
            if (!regex.test(govId.id_number)) return false;
          }

          if (idType.requires_expiry && (!govId.expiry_date || new Date(govId.expiry_date) < new Date())) {
            return false;
          }
        }

        return true;
      });
    }
  },

  mounted() {
    this.setDates();
    this.loadDepartments();
    this.loadDropdownData();
    this.loadGovernmentIdTypes();
    this.loadEmployee();
  },

  methods: {
    setDates() {
      const today = new Date();
      this.today = today.toISOString().split('T')[0];

      const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      this.maxDate = eighteenYearsAgo.toISOString().split('T')[0];
    },

    async loadDepartments() {
      try {
        const data = new FormData();
        data.append("function", "getDepartments");
        const res = await execute(data, authUrl);
        if (res && res.data && res.data.success) {
          this.departments = res.data.data?.departments || res.data.departments || [];
        }
      } catch (error) {
        console.error("Error loading departments:", error);
      }
    },

    async loadDropdownData() {
      try {
        const docData = new FormData();
        docData.append("function", "getDocumentTypes");
        const docRes = await execute(docData, authUrl);
        if (docRes && docRes.data && docRes.data.success) {
          this.documentTypes = docRes.data.data.documentTypes;
        }

        const relData = new FormData();
        relData.append("function", "getRelationshipTypes");
        const relRes = await execute(relData, authUrl);
        if (relRes && relRes.data && relRes.data.success) {
          this.relationshipTypes = relRes.data.data.relationshipTypes;
        }
      } catch (error) {
        console.error("Error loading dropdown data:", error);
      }
    },

    async loadGovernmentIdTypes() {
      try {
        const data = new FormData();
        data.append("function", "getGovernmentIdTypes");
        const res = await execute(data, authUrl);
        if (res && res.data && res.data.success) {
          this.governmentIdTypes = res.data.data.governmentIdTypes || [];
        }
      } catch (error) {
        console.error("Error loading government ID types:", error);
      }
    },

    async loadEmployee() {
      this.loading = true;
      try {
        const data = new FormData();
        data.append("function", "getEmployeeWithDetails");
        data.append("employeeId", this.$route.params.id || sessionStorage.getItem("employeeId"));

        const res = await execute(data, authUrl);

        if (res && res.data && res.data.success) {
          const empData = res.data.data;

          this.employee = {
            id: empData.employee.id,
            empNo: empData.employee.empNo,
            firstName: empData.employee.firstName,
            middleName: empData.employee.middleName || '',
            lastName: empData.employee.lastName,
            email: empData.employee.email,
            phone: empData.employee.phone,
            nationalId: empData.employee.nationalId,
            gender: empData.employee.gender,
            dateOfBirth: empData.employee.dateOfBirth,
            nationality: empData.employee.nationality || 'Kenya',
            employmentType: empData.employee.employmentType,
            hireDate: empData.employee.hireDate,
            departmentID: empData.employee.departmentID,
            departmentName: empData.employee.departmentName,
            status: empData.employee.status || 'Active'
          };

          this.governmentIds = empData.governmentIds || [];
          this.documents = empData.documents.map(doc => ({...doc, errors: {}, uploading: false}));
          this.emergencyContacts = empData.emergencyContacts.map(contact => ({...contact, errors: {}}));
          this.nextOfKin = empData.nextOfKin.map(kin => ({
            ...kin,
            isCoveredInBenefits: kin.isCoveredInBenefits === '1',
            errors: {}
          }));
        } else {
          throw new Error(res.data?.message || 'Failed to load employee');
        }
      } catch (error) {
        this.errorMessage = error.message;
        const modal = new bootstrap.Modal(document.getElementById('errorModal'));
        modal.show();
      } finally {
        this.loading = false;
      }
    },

    // Government ID Methods - FIXED to avoid infinite loop
    getGovIdValue(idTypeCode, field) {
      const govId = this.governmentIds.find(id => id.id_type === idTypeCode);
      if (govId) {
        return govId[field];
      }
      // Return default values without modifying array
      const defaults = {
        id_number: '',
        is_active: 1,
        issue_date: null,
        expiry_date: null,
        notes: ''
      };
      return defaults[field];
    },

    updateGovIdField(idTypeCode, field, value) {
      let govId = this.governmentIds.find(id => id.id_type === idTypeCode);

      if (!govId) {
        govId = {
          id_type: idTypeCode,
          id_number: '',
          country_code: this.getCountryCode(this.employee.nationality),
          issue_date: null,
          expiry_date: null,
          is_verified: 0,
          is_active: 1,
          notes: ''
        };
        this.governmentIds.push(govId);
      }

      govId[field] = value;
    },

    getCountryCode(nationality) {
      const countryMap = {
        'Kenya': 'KE',
        'India': 'IN',
        'United States': 'US',
        'United Kingdom': 'GB'
      };
      return countryMap[nationality] || 'KE';
    },

    onNationalityChange() {
      this.validateField('nationality');
      this.governmentIds = [];
      this.governmentIdErrors = {};
    },

    validateGovernmentId(idType) {
      const govId = this.governmentIds.find(id => id.id_type === idType.id_type_code);

      delete this.governmentIdErrors[idType.id_type_code];

      if (idType.is_mandatory && (!govId || !govId.id_number || govId.id_number.trim() === '')) {
        this.governmentIdErrors[idType.id_type_code] = `${idType.id_type_name} is required`;
        return false;
      }

      if (govId && govId.id_number) {
        if (idType.min_length && govId.id_number.length < idType.min_length) {
          this.governmentIdErrors[idType.id_type_code] = `Minimum ${idType.min_length} characters required`;
          return false;
        }

        if (idType.max_length && govId.id_number.length > idType.max_length) {
          this.governmentIdErrors[idType.id_type_code] = `Maximum ${idType.max_length} characters allowed`;
          return false;
        }

        if (idType.format_pattern) {
          const regex = new RegExp(idType.format_pattern);
          if (!regex.test(govId.id_number)) {
            this.governmentIdErrors[idType.id_type_code] = `Invalid format. Expected: ${idType.format_example}`;
            return false;
          }
        }

        if (idType.requires_expiry && (!govId.expiry_date || new Date(govId.expiry_date) < new Date())) {
          this.governmentIdErrors[idType.id_type_code] = 'Valid expiry date is required';
          return false;
        }
      }

      return true;
    },

    validateAllGovernmentIds() {
      let isValid = true;
      this.governmentIdErrors = {};

      this.filteredGovernmentIdTypes.forEach(idType => {
        if (!this.validateGovernmentId(idType)) {
          isValid = false;
        }
      });

      return isValid;
    },

    nextStep() {
      // Validate before proceeding to ensure error messages are shown
      if (this.currentStep === 1) {
        this.validateStep1();
      } else if (this.currentStep === 2) {
        this.validateAllGovernmentIds();
      }

      if (this.canProceedToNextStep) {
        this.currentStep++;
      }
    },

    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    validateStep1() {
      const requiredFields = ['empNo', 'firstName', 'middleName', 'lastName', 'email',
        'phone', 'nationalId', 'gender', 'dateOfBirth', 'nationality',
        'hireDate', 'departmentID', 'employmentType', 'status'];

      let isValid = true;
      requiredFields.forEach(field => {
        this.validateField(field);
        if (this.errors[field]) {
          isValid = false;
        }
      });

      return isValid;
    },

    addDocument() {
      this.documents.push({
        documentType: '',
        name: '',
        documentNumber: '',
        filePath: '',
        fileSize: '',
        fileType: '',
        uploadDate: new Date().toISOString().split('T')[0],
        validTill: '',
        uploading: false,
        errors: {}
      });
    },

    removeDocument(index) {
      this.documents.splice(index, 1);
    },

    onDocumentTypeChange(index, event) {
      const selectedType = event.target.value;
      if (selectedType) {
        this.documents[index].name = selectedType;
      } else {
        this.documents[index].name = '';
      }
    },

    async onDocumentFileChange(index, event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 5 * 1024 * 1024) {
        this.$toast?.error("File size must be less than 5MB") || alert('File size must be less than 5MB');
        event.target.value = '';
        return;
      }

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        this.$toast?.error("Only PDF, JPG, PNG, DOC, and DOCX files are allowed") ||
        alert('Only PDF, JPG, PNG, DOC, and DOCX files are allowed');
        event.target.value = '';
        return;
      }

      try {
        this.documents[index].uploading = true;

        const formData = new FormData();
        formData.append('function', 'uploadDocument');
        formData.append('file', file);
        formData.append('documentType', this.documents[index].documentType || 'general');
        formData.append('employeeId', this.employee.id || '');

        const response = await execute(formData, authUrl);

        if (response && response.data && response.data.success) {
          this.documents[index].filePath = response.data.data.filePath;
          this.documents[index].fileSize = response.data.data.fileSize;
          this.documents[index].fileType = response.data.data.fileType;
          this.documents[index].uploadDate = response.data.data.uploadDate;
          this.documents[index].originalFileName = response.data.data.originalName;

          this.$toast?.success("Document uploaded successfully") ||
          console.log('Document uploaded successfully');
        } else {
          throw new Error(response.data?.message || 'Upload failed');
        }
      } catch (error) {
        console.error('Upload error:', error);
        this.$toast?.error("Failed to upload document: " + error.message) ||
        alert('Failed to upload document: ' + error.message);
        event.target.value = '';

        this.documents[index].filePath = '';
        this.documents[index].fileSize = '';
        this.documents[index].fileType = '';
      } finally {
        this.documents[index].uploading = false;
      }
    },

    addEmergencyContact() {
      this.emergencyContacts.push({
        name: '',
        phoneNumber: '',
        email: '',
        relationship: '',
        errors: {}
      });
    },

    removeEmergencyContact(index) {
      this.emergencyContacts.splice(index, 1);
    },

    addNextOfKin() {
      this.nextOfKin.push({
        name: '',
        phoneNumber: '',
        email: '',
        relationship: '',
        isCoveredInBenefits: false,
        errors: {}
      });
    },

    removeNextOfKin(index) {
      this.nextOfKin.splice(index, 1);
    },

    validateField(field) {
      delete this.errors[field];

      const requiredFields = {
        empNo: 'Employee number',
        firstName: 'First name',
        middleName: 'Middle name',
        lastName: 'Last name',
        nationalId: 'National ID',
        gender: 'Gender',
        dateOfBirth: 'Date of birth',
        nationality: 'Nationality',
        hireDate: 'Hire date',
        departmentID: 'Department',
        employmentType: 'Employment type',
        status: 'Status'
      };

      if (requiredFields[field] && !this.employee[field]) {
        this.errors[field] = `${requiredFields[field]} is required`;
      }

      if (field === 'email') {
        if (!this.employee.email) {
          this.errors[field] = 'Email is required';
        } else if (!this.isValidEmail(this.employee.email)) {
          this.errors[field] = 'Please enter a valid email address';
        }
      }

      if (field === 'phone') {
        if (!this.employee.phone) {
          this.errors[field] = 'Phone number is required';
        } else if (!this.isValidPhone(this.employee.phone)) {
          this.errors[field] = 'Please enter a valid phone number';
        }
      }
    },

    validateDynamicArrays() {
      let isValid = true;

      this.documents.forEach((doc, index) => {
        doc.errors = {};
        if (!doc.documentType) {
          doc.errors.documentType = 'Document type is required';
          isValid = false;
        }
        if (!doc.name) {
          doc.errors.name = 'Document name is required';
          isValid = false;
        }
      });

      this.emergencyContacts.forEach((contact, index) => {
        contact.errors = {};
        if (!contact.name) {
          contact.errors.name = 'Name is required';
          isValid = false;
        }
        if (!contact.phoneNumber) {
          contact.errors.phoneNumber = 'Phone number is required';
          isValid = false;
        }
        if (!contact.relationship) {
          contact.errors.relationship = 'Relationship is required';
          isValid = false;
        }
      });

      this.nextOfKin.forEach((kin, index) => {
        kin.errors = {};
        if (!kin.name) {
          kin.errors.name = 'Name is required';
          isValid = false;
        }
        if (!kin.phoneNumber) {
          kin.errors.phoneNumber = 'Phone number is required';
          isValid = false;
        }
        if (!kin.relationship) {
          kin.errors.relationship = 'Relationship is required';
          isValid = false;
        }
      });

      return isValid;
    },

    validateAllFields() {
      const fields = ['empNo', 'firstName', 'middleName', 'lastName', 'email',
        'phone', 'nationalId', 'gender', 'dateOfBirth', 'nationality',
        'hireDate', 'departmentID', 'employmentType', 'status'];

      fields.forEach(field => this.validateField(field));

      const step1Valid = Object.keys(this.errors).length === 0;
      const govIdsValid = this.validateAllGovernmentIds();
      const arraysValid = this.validateDynamicArrays();

      return step1Valid && govIdsValid && arraysValid;
    },

    isValidEmail(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },

    isValidPhone(phone) {
      const re = /^[\d\s\-\+\(\)]+$/;
      return re.test(phone) && phone.replace(/\D/g, '').length >= 9;
    },

    async validateAndSubmit() {
      if (!this.validateAllFields()) {
        this.$toast?.error("Please fill in all required fields correctly") ||
        alert("Please fill in all required fields correctly");
        return;
      }

      await this.updateEmployee();
    },

    async updateEmployee() {
      this.loading = true;

      try {
        const selectedDept = this.departments.find(d => d.id === this.employee.departmentID);
        if (selectedDept) {
          this.employee.departmentName = selectedDept.departmentName;
        }

        const preparedNextOfKin = this.nextOfKin.map(kin => ({
          ...kin,
          isCoveredInBenefits: kin.isCoveredInBenefits ? '1' : '0'
        }));

        const activeGovernmentIds = this.governmentIds.filter(id =>
            id.is_active && id.id_number && id.id_number.trim() !== ''
        );

        const data = new FormData();
        data.append("function", "updateEmployeeWithDetails");
        data.append("employeeId", this.employee.id);
        data.append("employee", JSON.stringify(this.employee));
        data.append("governmentIds", JSON.stringify(activeGovernmentIds));
        data.append("documents", JSON.stringify(this.documents));
        data.append("emergencyContacts", JSON.stringify(this.emergencyContacts));
        data.append("nextOfKin", JSON.stringify(preparedNextOfKin));

        const response = await execute(data, authUrl);

        if (response && response.data && response.data.success) {
          this.successMessage = `Employee ${this.employee.firstName} ${this.employee.lastName} and all details have been updated successfully.`;

          const modal = new bootstrap.Modal(document.getElementById('successModal'));
          modal.show();
        } else {
          throw new Error(response.data?.message || 'Failed to update employee');
        }
      } catch (error) {
        this.errorMessage = error.message || 'An error occurred while updating the employee';

        const modal = new bootstrap.Modal(document.getElementById('errorModal'));
        modal.show();
      } finally {
        this.loading = false;
      }
    },

    gotTo(route) {
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    }
  }
};
</script>

<style scoped>
.progress-nav {
  padding: 1rem 0;
}

.progress-steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.progress-steps::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 2px;
  background: #e9ecef;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  background: white;
  padding: 0 1rem;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
}

.step-title {
  font-size: 0.875rem;
  color: #6c757d;
  text-align: center;
  transition: all 0.3s ease;
}

.step.active .step-number {
  background: #5b73e8;
  color: white;
}

.step.active .step-title {
  color: #5b73e8;
  font-weight: 600;
}

.step.completed .step-number {
  background: #34c38f;
  color: white;
}

.step.completed .step-title {
  color: #34c38f;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.form-control:focus,
.form-select:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

.is-invalid {
  border-color: #f46a6a !important;
}

.avatar-lg {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.card {
  transition: box-shadow 0.3s ease;
  margin-bottom: 1.5rem;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.input-group-text {
  background-color: #f8f9fa;
  border-right: none;
}

.input-group .form-control,
.input-group .form-select {
  border-left: none;
}

.input-group:focus-within .input-group-text {
  border-color: #5b73e8;
  color: #5b73e8;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.border {
  border-color: #e9ecef !important;
}

.border:hover {
  border-color: #5b73e8 !important;
  transition: border-color 0.3s ease;
}

.border-danger {
  border-color: #f46a6a !important;
  border-width: 2px !important;
}

@media (max-width: 768px) {
  .progress-steps {
    flex-wrap: wrap;
    gap: 1rem;
  }

  .step {
    flex: 1;
    min-width: calc(50% - 0.5rem);
  }

  .progress-steps::before {
    display: none;
  }

  .step-title {
    font-size: 0.75rem;
  }
}
</style>